import React, { useState, useEffect, useRef } from 'react';

import { 
  Character,
  CharacterSlot,
  CharacterSheetInterface,
} from "@dndModels";

// import API from "../../../utilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import CommonUtilities from "@utilities/common_utilities";

import CharacterResourceBoxes from "@dndComponents/character/misc/CharacterResourceBoxes";

interface Props {
  character: Character; 
  char_interface: CharacterSheetInterface;
  slot: CharacterSlot;
  shared: boolean;
}

// const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const common_util = CommonUtilities.getInstance();

export default function CharacterSlotInput({ 
  character,
  char_interface,
  slot,
  shared,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [change_time, setChangeTime] = useState(0);
  const [chk_change_time, setChkChangeTime] = useState(false);
  const [use_slot, setUseSlot] = useState<CharacterSlot>(new CharacterSlot());
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (!fetched) {
      character.subscription_holder.subscribe("Resources", mounted, resourcesChanged);
      setUseSlot(slot.clone());
      setFetched(true);
    }
    // eslint-disable-next-line
  }, [fetched, setFetched]);

  const resourcesChanged = () => {
    setReloading(true);
  }

  useEffect(() => {
    if (reloading) {
      setReloading(false);
      setUseSlot(slot.clone());
    }
    // eslint-disable-next-line
  }, [reloading, setReloading]);

  useEffect(() => {
    if (change_time > 0) {
      // console.log(use_slot.used);
      const now = common_util.get_time_number();
      // console.log(change_time);
      // console.log(now);
      if (change_time + 1 <= now) {
        // console.log("changing");
        setChangeTime(0);
        setTimeout(() => {
          updateCharacter();
        }, 1000);
      } else {
        setTimeout(() => {
          setChkChangeTime(!chk_change_time);
        }, 1000);
      }
    }
    // eslint-disable-next-line
  }, [change_time,chk_change_time]);

  const updateCharacter = () => {
    // debugger;
    character.changed();
    // onChange();
    char_util.resourcesChanged(character);
    // setReloading(true);
  }

  return (
    <CharacterResourceBoxes 
      label={ `${use_slot.level}` }
      used={ use_slot.used}
      total={use_slot.total}
      true_total={use_slot.true_total}
      created={ use_slot.created}
      type={use_slot.slot_name}
      show_type={false}
      character={character}
      shared={shared}
      onChange={(used: number) => {
        // debugger;
        const slots = char_interface.use_slots.find(o => o.level === slot.level && o.type_id === slot.type_id);
        if (slots) {
          // if (slot.type_id.includes("Created")) {
          //   slots.true_total = 0;
          //   slots.true_created -= used;
          //   if (slots.true_created < 0) {
          //     slots.true_created = 0;
          //   }
          // } else {
          slots.used = used;
          // }
          if (slots.is_resource) {
            const resource = char_interface.resources.find(o => o.type_id === slots.type_id && o.level === slots.level);
            if (resource) {
              resource.used = used;
            }
          }
          setUseSlot(slots.clone());
          setChangeTime(common_util.get_time_number());
          // char_util.recalcSpellSlots(character);
          // char_util.recalcActions(char_interface, character);
          // updateCharacter();
          // setReloading(true);
        }
      }}
    />
  );
}
